// Self-contained data for the Espiritu and Associates Law Office concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/09_Espiritu_and_Associates_Law_Office
// (research snapshot 2026-08-21). Owner/managing partner is unresolved — do not name or infer
// one. Only current, confirmed team members are used; historical staff (2019-2024) are not
// presented as currently with the firm.
export const BIZ = {
  name: "Espiritu and Associates Law Office",
  tagline: "A Bacolod Legal Team for Everyday Legal Needs",
  address: "C.L. Montelibano Avenue, Bacolod City, Negros Occidental 6100",
  phone: "+6334707340",
  phoneDisplay: "(034) 707-3400",
  mapEmbed: "https://www.google.com/maps?q=C.L.+Montelibano+Avenue+Bacolod+City&output=embed",
};

export const TEAM = [
  { name: "Adelaide Joie Lim", role: "Associate Attorney (with us since 2022, previously paralegal from 2019)" },
  { name: "Klaire Marie Araneta", role: "Team member" },
];

export const HOW_WE_ASSIST = [
  { title: "Legal Representation", text: "Representation and legal support handled by our associate attorneys." },
  { title: "Research & Drafting", text: "Legal research and document drafting, drawing on our paralegal and research support." },
  { title: "Compliance Support", text: "General compliance and legal-document assistance." },
];

export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "7 public reviews",
  note: "Individual review text was not recoverable — the rating reflects the aggregate shown in current public listings.",
};
